import {
  API_URL,
  ACTIVITY_KEY,
  USER_PROFILE_DATA_KEY,
  BROWSER_FINGER_PRINT_KEY,
  LAST_ACTIVITY_SYNC,
  SHOULD_LOG_ACTIVITY,
} from "../constants";
import { asyncLocalStorageGet, asyncLocalStorageSet } from "../activity/common";

function activityBackendSync() {
  window.document.addEventListener("visibilitychange", () => {
    if (window.document.visibilityState === "hidden") {
      pushData();
    }
  });
}

async function pushData() {
  if (SHOULD_LOG_ACTIVITY) {
    let activities = await asyncLocalStorageGet(ACTIVITY_KEY);
    const userProfileData = await asyncLocalStorageGet(USER_PROFILE_DATA_KEY);
    const gamePlayer = userProfileData?.gamePlayer;
    const browserFingerPrint = await asyncLocalStorageGet(
      BROWSER_FINGER_PRINT_KEY
    );
    const lastActivitySync = await asyncLocalStorageGet(LAST_ACTIVITY_SYNC);

    if (lastActivitySync) {
      activities = filterNewActivities(activities, +lastActivitySync);
    }

    if (
      Object.keys(activities).length > 1 &&
      Object.keys(browserFingerPrint).length
    ) {
      const payload = {
        fingerPrint: browserFingerPrint?.fingerPrint,
        activities,
        userProfileData,
        gamePlayer,
      };

      let headers = {
        type: "application/json",
      };

      let blob = new Blob([JSON.stringify(payload)], headers);

      try {
        navigator.sendBeacon(`${API_URL}/v1/activity-logger/push`, blob);
        asyncLocalStorageSet(
          LAST_ACTIVITY_SYNC,
          Object.keys(activities)[Object.keys(activities).length - 1]
        );
      } catch (error) {
        console.error("Error while syncing data with backed");
        console.error(error);
      }
    }
  }
}

function filterNewActivities(activities = {}, lastActivitySync = 0) {
  const objectLength = Object.keys(activities).length - 1;
  const objectKeys = Object.keys(activities);
  let filteredActivities = {};

  for (let i = objectLength; i >= 0; i--) {
    if (+objectKeys[i] >= lastActivitySync) {
      let temp = {};
      temp[objectKeys[i]] = activities[objectKeys[i]];
      filteredActivities = {
        ...temp,
        ...filteredActivities,
      };
    }
  }
  return filteredActivities;
}

export { pushData, activityBackendSync };
